import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';
import { getSearchStringFormObject } from '@Utils/getSearchStringFormObject';

import type { SellPointDataSearch, SellPointsParams, ShowroomType } from '@Types/SellPoints';
import type { ApiResponse } from '@Types/Api';

async function getSellPointsSearch(
  { params, pickupPoint }: SellPointsParams,
  showroomType?: ShowroomType,
) {
  const allParams = [{ q: params }, { storage: pickupPoint }, { showroomType }];
  const searchParams = getSearchStringFormObject(allParams);
  const url = `/backend/showroom/get-sell-points-list${searchParams.toString()}`;
  const res = await Api.queryProxi<ApiResponse<SellPointDataSearch[]>>(url);

  if (!res.ok) throw new BackendError(url, res);
  return res.data;
}

export default getSellPointsSearch;
